import {
  ArrowDownwardTwoTone,
  ArrowUpwardTwoTone,
  FilterList,
} from "@mui/icons-material";

import CheckboxSelector from "../../Schedules/components/CheckboxSelector";
import CloseSvg from "../../../assets/svgs/CloseSvg";
import IconComponent from "../../../components/DataTable/Icon";
import Loading from "../../../components/Loading";
import React from "react";
import Search from "../../../components/Search/SearchNew";
import Pagination from "../../../components/Pagination/Pagination";
import { Search_Icon } from "../../../assets/images";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { Tooltip } from "@mui/material";
import classNames from "classnames";
import moment from "moment/moment";
import { selectUser } from "../../../features/auth/authSlice";
import {
  useGetDepartmentsMutation,
  useGetPatientsMutation,
  useGetProvidersMutation,
  useGetPatientFiltersMutation,
} from "../../../features/organisation/organisationApiSlice";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import FilterSelect from "../../../components/Filter/FilterSelect";
import useDebounce from "../../../hooks/useDebounce";
import PatientAddModal from "./components/PatientAddModal";
import { useCreatePatientMutation } from "../../../features/patient/patientApiSlice";
import PatientZoneEditModal from "./components/PatientZoneEditModal";

const PatientList = ({ isMember }) => {
  const user = useSelector(selectUser);
  const [patients, setPatients] = React.useState([]);
  const [locations, setLocations] = React.useState([]);
  const [zones, setZones] = React.useState([]);
  const [statuses, setStatuses] = React.useState([]);
  const [departments, setDepartments] = React.useState([]);
  const [providers, setProviders] = React.useState([]);
  const [selectedPatient, setSelectedPatient] = React.useState(null);
  const [zoneEditModalOpen, setZoneEditModalOpen] = React.useState(false);

  const [statusFilter, setStatusFilter] = React.useState([]);
  const [locationFilter, setLocationFilter] = React.useState([]);
  const [searchFilter, setSearchFilter] = React.useState("");
  const [zoneFilter, setZoneFilter] = React.useState([]);
  const [zipFilter, setZipFilter] = React.useState([]);
  const [zips, setZips] = React.useState([]);
  const [count, setCount] = React.useState(0);

  // const [sortStatusOrder, setSortStatusOrder] = React.useState("none");
  // const [sortNameOrder, setSortNameOrder] = React.useState("none");
  const [sortBy, setSortBy] = React.useState("firstname");
  const [sortOrder, setSortOrder] = React.useState("asc");

  const [patientAddOpen, setPatientAddOpen] = React.useState(false);

  const search = useDebounce(searchFilter, 500);
  const location = useDebounce(locationFilter, 500);
  const status = useDebounce(statusFilter, 500);

  const navigate = useNavigate();

  // const handleSortStatus = (a, b) => {
  //   if (sortStatusOrder === "none") {
  //     return 0;
  //   } else if (sortStatusOrder === "asc") {
  //     return a.status.localeCompare(b.status);
  //   } else {
  //     return b.status.localeCompare(a.status);
  //   }
  // };

  const handleSelectPatient = (patient) => {
    setSelectedPatient(patient);
    setZoneEditModalOpen(true);
  };

  // const handleSortName = (a, b) => {
  //   if (sortNameOrder === "none") {
  //     return 0;
  //   } else if (sortNameOrder === "asc") {
  //     return a.name.localeCompare(b.name);
  //   } else {
  //     return b.name.localeCompare(a.name);
  //   }
  // };

  const handleLocationFilter = (location) => {
    if (locationFilter.indexOf(location) === -1) {
      setLocationFilter([...locationFilter, location]);
    } else {
      setLocationFilter(locationFilter.filter((filter) => filter !== location));
    }
  };

  const handleStatusFilter = (status) => {
    if (statusFilter.indexOf(status) === -1) {
      setStatusFilter([...statusFilter, status]);
    } else {
      setStatusFilter(statusFilter.filter((filter) => filter !== status));
    }
  };

  const handleZoneFilter = (zip) => {
    // if (zoneFilter.indexOf(zone) === -1) {
    //   setZoneFilter([...zoneFilter, zone]);
    // } else {
    //   setZoneFilter(zoneFilter.filter((filter) => filter !== zone));
    // }
    if (zipFilter.indexOf(zip) === -1) {
      setZipFilter([...zipFilter, zip]);
    } else {
      setZipFilter(zipFilter.filter((filter) => filter !== zip));
    }
  };

  const handlePatientClick = (patient) => {
    navigate(`/data-management/patients/${patient.id}`);
  };

  const [getPatients, { isLoading }] = useGetPatientsMutation();
  const [getPatientFilters, { isLoading: patientFiltersLoading }] =
    useGetPatientFiltersMutation();
  const [getProviders] = useGetProvidersMutation();
  const [getDepartments] = useGetDepartmentsMutation();
  const [createPatient, { isLoading: isCreating }] = useCreatePatientMutation();

  const fetchDepartments = async () => {
    const { data } = await getDepartments(user.organisation.id).unwrap();
    setDepartments(data);
  };

  const fetchProviders = async () => {
    const { data } = await getProviders({
      orgId: user.organisation.id,
      limit: 0,
      status: ["ACTIVE"],
      showZones: false,
      showConstraints: false,
      showLeaves: false,
    }).unwrap();
    setProviders(data);
  };

  const updatePatientZones = async (locationId, zones) => {
    setPatients((prev) =>
      prev.map((patient) =>
        patient.locationId === locationId
          ? {
              ...patient,
              zones: zones,
            }
          : patient
      )
    );
  };

  const fetchPatients = async ({
    limit,
    skip,
    search,
    location,
    status,
    zones,
    sortBy,
    sortOrder,
    zips,
  }) => {
    try {
      console.log({ sortBy, sortOrder });
      const payload = {
        orgId: user.organisation.id,
        limit,
        skip,
        search: search ?? searchFilter,
        location: location || locationFilter,
        status: status || statusFilter,
        zones: zones || zoneFilter,
        isMember,
        zips: zips || zipFilter,
      };
      if (sortBy && sortOrder) {
        payload["sortBy"] = sortBy;
        payload["sortOrder"] = sortOrder;
      }

      const { data, count } = await getPatients(payload).unwrap();

      setCount(count);
      setPatients(data);
    } catch (error) {
      setCount(0);
      setPatients([]);
      console.log(error?.data?.message || error.message);
    }
  };

  const fetchPatientFilters = async () => {
    const { data } = await getPatientFilters({
      orgId: user.organisation.id,
    }).unwrap();
    setStatuses(data?.statuses ?? []);
    setZones(data?.zones ?? []);
    setZips(data?.zips ?? []);
    setLocations(data.locations ?? []);
  };

  React.useEffect(() => {
    fetchPatientFilters();
  }, []);

  React.useEffect(() => {
    if (
      search.length > 0 ||
      location.length > 0 ||
      status.length > 0 ||
      zipFilter.length > 0
    ) {
      fetchPatients({
        limit: 20,
        skip: 0,
        search,
        location,
        status,
        zones: zoneFilter,
        sortBy,
        sortOrder,
        zips: zipFilter,
      });
    } else if (
      search.length === 0 &&
      location.length === 0 &&
      status.length === 0 &&
      zipFilter.length === 0
    ) {
      setCount(0);
      setPatients([]);
    }
  }, [search, location, status, zoneFilter, sortBy, sortOrder, zipFilter]);

  React.useEffect(() => {
    Promise.allSettled([fetchDepartments(), fetchProviders()]).then(
      (results) => {
        results.forEach((result) => {
          if (result.status === "rejected") {
            console.error("Error fetching data:", result.reason);
          }
        });
      }
    );
  }, []);

  const savePatient = async (e, patientData, insuranceData) => {
    try {
      const res = await createPatient({
        practiceId: user.organisation.practiceId,
        patient: {
          dob: moment(patientData.dob).format("MM/DD/YYYY"),
          firstname: patientData.firstname,
          lastname: patientData.lastname,
          sex: patientData.sex || undefined,
          address2: patientData.address2 || undefined,
          address1: patientData.address1 || undefined,
          city: patientData.city || undefined,
          state: patientData.state || undefined,
          zip: patientData.zip || undefined,
          departmentid: patientData.departmentid || undefined,
          email: patientData.email || undefined,
          homephone: patientData.homephone || undefined,
          mobilephone: patientData.mobilephone || undefined,
          notes: patientData.notes || undefined,
          primaryproviderid: patientData.primaryproviderid || undefined,
          driverslicensenumber: patientData.driverslicensenumber || undefined,
          ssn: patientData.ssn || undefined,
        },
        insurance: {
          insurancepackageid: insuranceData.insurancepackageid || undefined,
          insuranceidnumber: insuranceData.insuranceidnumber || undefined,
          sequencenumber: insuranceData.sequencenumber || undefined,
          policynumber: insuranceData.policynumber || undefined,
          issuedate: insuranceData.issuedate || undefined,
          expirationdate: insuranceData.expirationdate || undefined,
          updateappointments: insuranceData.updateappointments || undefined,
          lob: insuranceData.lob || undefined,
          payer: insuranceData.payer || undefined,
          subscriber_plan_id: insuranceData.policynumber || undefined,
        },
        publishToEhr: !isMember,
      }).unwrap();

      const patientsList = [
        {
          ...res.data,
        },
        ...patients,
      ];
      setPatients(patientsList);
    } catch (error) {
      throw new Error(error?.data?.message || error.message);
    }
  };

  const Avatar = ({ name, image }) => {
    return (
      <>
        {image !== null ? (
          <div className="flex gap-2 items-center">
            <img
              src={image}
              alt={name}
              className="object-cover w-10 h-10 rounded-full"
            />
            <p className="m-0 font-semibold">{name}</p>
          </div>
        ) : (
          <p className="flex justify-center items-center m-0 w-10 h-10 text-white rounded-full bg-primaryblue">
            {name
              .split(" ")
              .map((n) => n[0])
              .join("")}
          </p>
        )}
      </>
    );
  };

  return (
    <div className="flex flex-col items-start py-4 overflow-hidden h-[calc(100vh-100px)]">
      <Loading loading={isLoading} />
      <div className="flex flex-row gap-3 justify-between items-center px-16 w-full">
        <div className="flex flex-row gap-12 items-center w-full">
          <h1 className="m-0 text-2xl font-bold whitespace-nowrap w-fit">
            {isMember ? "Members" : "Patients"}{" "}
            <span className="ml-2 text-base font-bold text-primaryblue">
              {count}
            </span>
          </h1>
          <div className="flex flex-row gap-8 items-center w-full max-w-7xl">
            {(isMember
              ? user?.permissions?.includes("members_dm.search")
              : user?.permissions?.includes("patients_dm.search")) && (
              <Search value={searchFilter} setValue={setSearchFilter} />
            )}
            {(isMember
              ? user?.permissions?.includes("members_dm.filter_location")
              : user?.permissions?.includes("patients_dm.filter_location")) && (
              <FilterSelect
                value={locationFilter}
                handleChange={handleLocationFilter}
                data={locations}
                placeholder="Filter by Location..."
                enableSearch={true}
              />
            )}
            {(isMember
              ? user?.permissions?.includes("members_dm.filter_status")
              : user?.permissions?.includes("patients_dm.filter_status")) && (
              <FilterSelect
                value={statusFilter}
                handleChange={handleStatusFilter}
                data={statuses}
                placeholder="Filter by Status..."
              />
            )}
            {!isMember &&
              (isMember
                ? user?.permissions?.includes("members_dm.filter_zone")
                : user?.permissions?.includes("patients_dm.filter_zone")) && (
                <FilterSelect
                  value={zipFilter}
                  handleChange={handleZoneFilter}
                  data={zips}
                  placeholder="Filter by Zip..."
                  enableSearch={true}
                />
              )}
          </div>
        </div>
        {(isMember
          ? user?.permissions?.includes("members_dm.add_member")
          : user?.permissions?.includes("patients_dm.add_patient")) && (
          <button
            onClick={() => {
              setPatientAddOpen(true);
            }}
            className="flex justify-center items-center px-4 py-2 text-sm font-bold text-white whitespace-nowrap rounded-lg bg-primaryblue"
          >
            {isMember ? "Add Member" : "Add Patient"}
          </button>
        )}
      </div>
      <div className="px-16 mt-2 w-full">
        <Pagination count={count} api={fetchPatients} />
        <div className="relative w-full mb-2 overflow-x-auto overflow-y-auto bg-white rounded-lg shadow max-h-[calc(100vh-230px)]">
          <table className="relative w-full bg-white border-collapse table-auto whitespace-no-wrap table-striped">
            <thead>
              <tr className="h-16 text-base font-bold text-left text-white whitespace-nowrap bg-primaryblue">
                <th className="px-4 py-3">
                  <div className="flex flex-row gap-2 items-center">
                    <p className="m-0">Name</p>
                    <button
                      className="flex flex-col gap-1 items-center"
                      onClick={() => {
                        if (sortBy == "firstname") {
                          if (!sortOrder) {
                            setSortOrder("asc");
                          }
                          if (sortOrder === "asc") {
                            setSortOrder("desc");
                          }
                          if (sortOrder === "desc") {
                            setSortOrder("");
                          }
                        } else {
                          setSortBy("firstname");
                          setSortOrder("asc");
                        }
                      }}
                    >
                      {sortBy == "firstname" && sortOrder === "asc" ? (
                        <Tooltip title="Sort Descending">
                          <ArrowDownwardTwoTone />
                        </Tooltip>
                      ) : sortBy == "firstname" && sortOrder === "desc" ? (
                        <Tooltip title="Sort Ascending">
                          <ArrowUpwardTwoTone />
                        </Tooltip>
                      ) : (
                        // <div className="flex items-center h-4">
                        //   <div className="w-6 h-[2px] bg-white" />
                        // </div>
                        <div className="flex items-center providerlist-icon">
                          <SwapVertIcon />
                        </div>
                      )}
                    </button>
                  </div>
                </th>
                <th className="px-4 py-3">Date of Birth</th>
                <th className="px-4 py-3">Gender</th>
                <th className="px-4 py-3">EHR ID</th>
                <th className="px-4 py-3">Location</th>
                {process.env.REACT_APP_ENV === "dev" && (
                  <th className="px-4 py-3">Coverage</th>
                )}
                <th className="px-4 py-3">
                  <div className="flex flex-row gap-2 items-center">
                    <p className="m-0">Status</p>
                    <button
                      className="flex flex-col gap-1 items-center"
                      onClick={() => {
                        if (sortBy == "status") {
                          if (!sortOrder) {
                            setSortOrder("asc");
                          }
                          if (sortOrder === "asc") {
                            setSortOrder("desc");
                          }
                          if (sortOrder === "desc") {
                            setSortOrder("");
                          }
                        } else {
                          setSortBy("status");
                          setSortOrder("asc");
                        }
                      }}
                    >
                      {sortBy == "status" && sortOrder === "asc" ? (
                        <Tooltip title="Sort Descending">
                          <ArrowDownwardTwoTone />
                        </Tooltip>
                      ) : sortBy == "status" && sortOrder === "desc" ? (
                        <Tooltip title="Sort Ascending">
                          <ArrowUpwardTwoTone />
                        </Tooltip>
                      ) : (
                        // <div className="flex items-center h-4">
                        //   <div className="w-6 h-[2px] bg-white" />
                        // </div>
                        <div className="flex items-center providerlist-icon">
                          <SwapVertIcon />
                        </div>
                      )}
                    </button>
                  </div>
                </th>
                {/* <th className="px-4 py-3">Edit</th> */}
              </tr>
            </thead>
            <tbody>
              {patients.length === 0 ? (
                <tr>
                  <td
                    colSpan={process.env.REACT_APP_ENV === "dev" ? 10 : 9}
                    className="py-6 text-lg text-center text-gray-400"
                  >
                    No records found
                  </td>
                </tr>
              ) : (
                patients
                  .filter(Boolean)
                  // .filter((patient) =>
                  //   patient.name
                  //     .toLowerCase()
                  //     .includes(searchFilter.toLowerCase())
                  // )
                  // .filter(
                  //   (patient) =>
                  //     statusFilter.length === 0 ||
                  //     statusFilter.indexOf(patient.status) !== -1
                  // )
                  // .filter(
                  //   (patient) =>
                  //     locationFilter.length === 0 ||
                  //     locationFilter.indexOf(
                  //       patient.locationName === null
                  //         ? "Private Residence"
                  //         : patient.locationName
                  //     ) !== -1
                  // )
                  // ?.sort((a, b) => handleSortName(a, b))
                  // ?.sort((a, b) => handleSortStatus(a, b))
                  ?.map((patient, index) => (
                    <tr
                      className={classNames(
                        "text-left text-gray-900 h-24 whitespace-nowrap",
                        index !== patients.length - 1
                          ? "border-b"
                          : "border-none"
                      )}
                      key={index}
                    >
                      <td className="px-4 py-3 text-left">
                        <button
                          onClick={() => (isMember ? user?.permissions?.includes('members_dm.view_specfic_member') : user?.permissions?.includes('patients_dm.view_specific_patient')) && handlePatientClick(patient)}
                          className="flex flex-row gap-4 items-center"
                        >
                          <Avatar name={patient.name} image={null} />
                          <p className="m-0 font-semibold underline">
                            {patient.name}
                          </p>
                        </button>
                      </td>
                      <td className="px-4 py-3 text-left text-gray-700">
                        {moment(patient.dob).format("MM/DD/YYYY")}
                      </td>
                      <td className="px-4 py-3 text-left text-gray-700">
                        {patient.sex === "F" ? "Female" : "Male"}
                      </td>
                      <td className="px-4 py-3 text-left text-gray-700">
                        {patient.patientEhrId}
                      </td>
                      <td className="px-4 py-3 text-left text-gray-700">
                        {patient.locationName === null
                          ? "Private Residence"
                          : patient.locationName}
                      </td>
                      {process.env.REACT_APP_ENV === "dev" && (
                        <td className="gap-2 px-4 py-3 text-left text-gray-700">
                          {/* {patient?.zones?.length > 0
                            ? patient?.zones
                                ?.slice(0, 3)
                                ?.map((zone) => zone.name)
                                .join(", ") +
                              (patient?.zones?.length > 3
                                ? `, +${patient?.zones?.length - 3} more`
                                : "")
                            : "NA"} */}
                          {patient?.zip}
                          {/* <button className="pt-2 ml-2">
                            <IconComponent
                              tooltip="Edit Zone"
                              icon={"Edit_Icon"}
                              i={patient}
                              onClick={() => {
                                handleSelectPatient(patient);
                              }}
                              disabled={isMember ? !user?.permissions?.includes('members_dm.edit_member_zones') : !user?.permissions?.includes('patients_dm.update_patient_zones')}
                            />
                          </button> */}
                        </td>
                      )}
                      <td className="px-4 py-3 text-left text-gray-700">
                        <div
                          className={classNames(
                            patient.status.toUpperCase() === "ACTIVE"
                              ? "bg-subtlegreen border-[1px] border-primarygreen text-primarygreen"
                              : "bg-primarylightgrey border-[1px] border-primarygrayborder text-primarytextgrey",
                            "rounded-md text-center flex flex-row gap-1 items-center px-2 w-fit"
                          )}
                        >
                          <div
                            className={classNames(
                              "w-2 h-2 rounded-full",
                              patient.status.toUpperCase() === "ACTIVE"
                                ? "bg-primarygreen"
                                : "bg-primarytextgrey"
                            )}
                          />
                          {patient.status}
                        </div>
                      </td>
                      {/* <td className="px-4 py-3 text-left">
                    <button
                      className="p-2 text-white rounded-md"
                      onClick={() => {}}
                    >
                      <IconComponent icon={"Edit_Icon"} i={provider.id} />
                    </button>
                  </td> */}
                    </tr>
                  ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      {patientAddOpen && (
        <PatientAddModal
          isOpen={patientAddOpen}
          setOpen={setPatientAddOpen}
          departments={departments}
          providers={providers}
          onSave={savePatient}
          isCreating={isCreating}
          isMember={isMember}
        />
      )}
      {selectedPatient && zoneEditModalOpen && (
        <PatientZoneEditModal
          open={zoneEditModalOpen}
          setOpen={setZoneEditModalOpen}
          patient={selectedPatient}
          updatePatientZones={updatePatientZones}
        />
      )}
    </div>
  );
};

export default PatientList;
